export const ROUTE_NAMES = {
  HOME: '/',
  LOGIN: '/login',
  ARTIST: '/artist',
  ALBUM: '/album',
  TRACK: '/track',
  PLAYLIST: '/playlist',
  SEARCH: '/search',
  PROFILE: '/profile',
  PROFILE_FOLLOWING: '/profile/following',
} as const;
